import {DesignMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/DesignMenuItems';
import {EditMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/EditMenuItems';
import {HelpMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/HelpMenuItems';
import {ViewMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/ViewMenuItems';
import {
    ContextMenu,
    ContextMenuDataSource,
    IContextMenuItem
} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {SyncStatus} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/syncStatus/SyncStatus';

const styles = require('./ExpandedTopMenu.less');
const cx = classnames.bind(styles);

export interface IExpandedTopMenuProps
{

}

@observer
export class ExpandedTopMenu extends React.Component<IExpandedTopMenuProps>
{
    @observable
    private _isMenuOpen:boolean = false;

    @observable
    private _activeRootMenuItem:string = null;

    private _getRootMenuItems():IContextMenuItem[]
    {
        return [
            {
                label: 'Design',
                dataSource: DesignMenuItems.build()
            },
            {
                label: 'Edit',
                dataSource: EditMenuItems.build()
            },
            {
                label: 'View',
                dataSource: ViewMenuItems.build()
            },
            // {
            //     label: 'Component',
            //     dataSource: ComponentMenuItems.build(),
            //     isDisabled: true
            // },
            // {
            //     label: 'Cell',
            //     dataSource: CellMenuItems.build(),
            //     isDisabled: true
            // },
            {
                label: 'Help',
                dataSource: HelpMenuItems.build()
            }
        ];
    }

    private _getMenuItemMouseEnterHandler(item:IContextMenuItem):(e:React.MouseEvent<HTMLElement>) => void
    {
        return action((e:React.MouseEvent<HTMLElement>) =>
        {
            if( item.isDisabled || !item.dataSource )
                return;

            this._activeRootMenuItem = item.label as string;
        });
    }

    private _getMenuItemClickHandler(item:IContextMenuItem):(e:React.MouseEvent<HTMLElement>) => void
    {
        return action((e:React.MouseEvent<HTMLElement>) =>
        {
            if( item.isDisabled || !item.dataSource )
                return;

            this._activeRootMenuItem = item.label as string;
            this._isMenuOpen = !this._isMenuOpen;
        });
    }

    private _getHideMenuHandler(item:IContextMenuItem):() => void
    {
        return action(() =>
        {
            if( this._activeRootMenuItem === item.label )
                this._isMenuOpen = false;
        });
    }

    public render()
    {
        return (
            <div className={cx('base')}>
                {
                    this._getRootMenuItems().map((item:IContextMenuItem) =>
                    {
                        const label = item.label as string;
                        const dataSource = item.dataSource as ContextMenuDataSource<IContextMenuItem>;
                        const isActive:boolean = label === this._activeRootMenuItem;
                        const isOpen:boolean = this._isMenuOpen && isActive;

                        return (
                            <ContextMenu
                                isOpen={isOpen}
                                key={label}
                                className={cx('menu')}
                                contentClassName={cx('menuContent')}
                                dataSource={dataSource}
                                onHide={this._getHideMenuHandler(item)}
                                popupGroup={'expanded-top-menu-group'}
                            >
                                <div
                                    className={cx('rootMenuItem', {isOpen, isDisabled: item.isDisabled})}
                                    onMouseEnter={this._getMenuItemMouseEnterHandler(item)}
                                    onClick={this._getMenuItemClickHandler(item)}
                                >
                                    {item.label}
                                </div>
                            </ContextMenu>
                        );
                    })
                }
                <SyncStatus />
            </div>
        );
    }
}
